import { round } from 'es-toolkit';
// components
import { TSessionByType } from '@newo/api/gateway';
import EmptyView from '@/pages/Report/components/EmptyView';
import SessionTypeItem from '@/pages/Report/components/SessionDistribution/components/ByType/components/SessionTypeItem';
import ByTypePieChart from '@/pages/Report/components/SessionDistribution/components/ByType/components/ByTypePieChart';
// utils

interface ByTypeProps {
    className?: string;
    data: TSessionByType;
}

const FULL_OPACITY = 100;
const OPACITY_MAX_VALUE = 90;
const PERCENTAGE_MULTIPLIER = 100;
const DECIMAL_PLACES = 2;

const calcOpacity = (index: number, total: number) => {
    if (total <= 1) {
        return FULL_OPACITY;
    }
    return FULL_OPACITY - index * (OPACITY_MAX_VALUE / (total - 1));
};

const ByType = ({ className, data }: ByTypeProps) => {
    const leadsLength = data.sessions_leads.length;
    const nonLeadsLength = data.sessions_non_leads.length;
    const leads = data.sessions_leads.map((lead, index) => {
        return {
            value: lead.total_sessions,
            name: lead.argument,
            color: `rgb(70 211 239 / ${calcOpacity(index, leadsLength)}%)`
        };
    });
    const nonleads = data.sessions_non_leads.map((lead, index) => {
        return {
            value: lead.total_sessions,
            name: lead.argument,
            color: `rgba(199 199 203 / ${calcOpacity(index, nonLeadsLength)}%)`
        };
    });

    const chartData = [...leads, ...nonleads];
    const totalSessions = chartData.reduce(
        (accumulator, current) => accumulator + current.value,
        0
    );

    return (
        <div className={className}>
            <div className="font-semibold mb-2">by Type</div>
            {chartData.length === 0 && <EmptyView className="h-80" />}
            {chartData.length > 0 && (
                <div className="grid md:grid-cols-2 gap-8">
                    <div>
                        <ByTypePieChart data={chartData} />
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="text-xs text-gray-6">
                            Leads By Type:
                        </div>
                        <div className="text-sm overflow-hidden rounded-sm mb-4">
                            {leads.map(({ name, color, value }) => (
                                <SessionTypeItem
                                    isLead
                                    color={color}
                                    key={name}
                                    name={name}
                                    value={`${value} (${round((value / totalSessions) * PERCENTAGE_MULTIPLIER, DECIMAL_PLACES)}%)`}
                                />
                            ))}
                        </div>
                        <div className="text-xs text-gray-6">
                            Non-leads By Type:
                        </div>
                        <div className="text-sm overflow-hidden rounded-sm">
                            {nonleads.map(({ name, color, value }) => (
                                <SessionTypeItem
                                    color={color}
                                    isLead={false}
                                    key={name}
                                    name={name}
                                    value={`${value} (${round((value / totalSessions) * PERCENTAGE_MULTIPLIER, DECIMAL_PLACES)}%)`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ByType;
